<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OiKNbT/tc-custom/9780544052499.jpg?1736857784943" alt="This image is the cover for the book Refiner's Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Refiner's Fire
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An Israeli soldier’s life flashes before his eyes in this epic tale: “As if <i>The Odyssey </i>had been updated and rewritten by Dylan Thomas” (<i>The Listener</i>, UK).</b></p><p>In 1947, Marshall Pearl is orphaned at birth aboard an immigrant ship off the coast of Palestine. Brought to America, he grows up a child of the Hudson Valley, determined to see the world in all its beauty and ferocity. His epic journey takes him from Jamaica to Harvard; from Great Plains slaughterhouses to the Mexican desert; and from the sea to the Alps. Marshall is eventually drawn to Israel to confront the circumstance of his birth in a crucible of war, magic, suffering, and grace.</p><p>We first meet Marshall among the mortally wounded Israeli soldiers who are being transferred to Haifa during the Yom Kippur War. From there we follow Marshall—along with his memories and dreams—as he reconstructs his life, galvanizing strength through all that he has learned, suffered, and hoped.</p><b>“Superb...A first-rate odyssey, full of insight and humor and hard-earned truths”—<i>San Francisco Chronicle</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Helprin
      </h2>
      
      <p class="authorDescription body article">Mark Helprin is the acclaimed author of Winter's Tale, A Soldier of the Great War, Freddy and Fredericka, The Pacific, Ellis Island, Memoir from Antproof Case, and numerous other works. His novels are read around the world, translated into over 20 languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21477b73